(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stockists"] && !Shopify.designMode) return;
  try {
    

(() => {
  if (customElements.get('sande-stockist-locator')) return;
  class SandeStockists extends HTMLElement {
    connectedCallback() {
      if (this.ready) { this.startMap(); return; }
      if (!this.querySelector('[data-ready]')) {
        if (!this.observer) {
          this.observer = new MutationObserver(() => this.connectedCallback());
          this.observer.observe(this, {childList:true, subtree:true});
        }
        return;
      }
      this.observer?.disconnect();
      this.observer = null;
      if (this.loadingEntries) return;
      this.loadingEntries = true;
      this.loadEntries().then(() => { if (this.isConnected) this.initialize(); }).catch(() => {}).finally(() => { this.loadingEntries = false; });
    }
    initialize() {
      this.ready = true;
      this.dataset.enhanced = 'true';
      this.querySelectorAll('.sande-stockists__stores').forEach(list => {
        [...list.children].sort((a,b) => a.querySelector('h4').textContent.localeCompare(b.querySelector('h4').textContent)).forEach(row => list.append(row));
      });
      const search = this.querySelector('[data-search]');
      const chips = [...this.querySelectorAll('[data-region]')];
      const groups = [...this.querySelectorAll('[data-code]')].map(element => ({
        element,
        count: element.querySelector('[data-count]'),
        rows: [...element.querySelectorAll('.sande-stockists__store')].map(row => ({
          element: row,
          text: this.normalize(row.textContent + ' ' + row.dataset.searchText + ' ' + element.querySelector('summary > span:first-child').textContent + ' ' + element.dataset.code)
        }))
      }));
      this.rows = groups.flatMap(group => group.rows).map((row, index) => ({...row, index, points: JSON.parse(row.element.dataset.points || '[]')}));
      this.querySelectorAll('[data-locate]').forEach(button => button.addEventListener('click', () => this.locate(this.rows.find(row => row.element === button.closest('.sande-stockists__store')))));
      this.querySelector('[data-map-retry]').addEventListener('click', () => this.startMap(true));
      const status = this.querySelector('[data-status]');
      const empty = this.querySelector('[data-empty]');
      const reset = this.querySelector('.sande-stockists__results-bar [data-reset]');
      let region = 'all';
      let savedOpen = null;
      const update = () => {
        const query = this.normalize(search.value);
        const tokens = query.split(' ').filter(Boolean);
        const filtered = Boolean(tokens.length || region !== 'all');
        if (filtered && !savedOpen) savedOpen = new Set(groups.filter(g => g.element.open).map(g => g.element));
        let total = 0;
        for (const group of groups) {
          const included = region === 'all' || group.element.dataset.code === region;
          let count = 0;
          for (const row of group.rows) {
            const match = included && tokens.every(token => row.text.includes(token));
            row.element.hidden = !match;
            if (match) count++;
          }
          total += count;
          group.element.hidden = count === 0;
          group.count.textContent = `${count} ${count === 1 ? this.dataset.single : this.dataset.plural}`;
          if (filtered) group.element.open = count > 0;
          else if (savedOpen) group.element.open = savedOpen.has(group.element);
        }
        if (!filtered) savedOpen = null;
        this.filteredRows = this.rows.filter(row => !row.element.hidden);
        this.syncMap();
        for (const chip of chips) chip.setAttribute('aria-pressed', String(chip.dataset.region === region));
        empty.hidden = total > 0;
        reset.hidden = !filtered;
        status.textContent = `${total} ${total === 1 ? this.dataset.single : this.dataset.plural}`;
      };
      search.addEventListener('input', update);
      search.addEventListener('search', update);
      chips.forEach(chip => chip.addEventListener('click', () => {region = chip.dataset.region; update();}));
      this.querySelectorAll('[data-reset]').forEach(button => button.addEventListener('click', () => {
        search.value = '';
        region = 'all';
        update();
        search.focus();
      }));
      this.querySelector('.sande-stockists__controls').hidden = false;
      chips.forEach(chip => { if (chip.dataset.region !== 'all') chip.hidden = !groups.some(group => group.element.dataset.code === chip.dataset.region && group.rows.length); });
      update();
      this.startMap();
    }
    async loadEntries() {
      const nav = this.querySelector('[data-pagination]');
      let next = nav.querySelector('[data-next]')?.href;
      const seen = new Set([...this.querySelectorAll('[data-handle]')].map(row => row.dataset.handle));
      while (next && this.isConnected) {
        const url = new URL(next, location.href);
        url.searchParams.set('section_id', this.dataset.sectionId);
        const response = await fetch(url, {signal: AbortSignal.timeout(15000)});
        if (!response.ok) throw new Error('Stockist list unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const locator = doc.querySelector('sande-stockist-locator');
        if (!locator) throw new Error('Missing stockist section');
        locator.querySelectorAll('[data-code]').forEach(group => {
          const list = this.querySelector(`[data-code="${group.dataset.code}"] ul`);
          group.querySelectorAll('[data-handle]').forEach(row => {
            if (!seen.has(row.dataset.handle)) { seen.add(row.dataset.handle); list.append(row); }
          });
        });
        const link = locator.querySelector('[data-next]');
        next = link ? new URL(link.getAttribute('href'), location.href).href : null;
        nav.replaceChildren(...[...locator.querySelector('[data-pagination]').childNodes]);
      }
      nav.hidden = true;
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
      clearTimeout(this.mapTimer);
      this.mapResizeObserver?.disconnect();
      this.mapInstance?.remove();
      this.mapInstance = null;
      this.mapReady = false;
    }
    async startMap(retry = false) {
      if (this.mapStarting) return;
      if (this.mapInstance) {
        if (!retry) return;
        clearTimeout(this.mapTimer);
        this.mapInstance?.remove();
        this.mapInstance = null;
        this.mapReady = false;
      }
      this.mapStarting = true;
      const loading = this.querySelector('[data-map-loading]');
      const error = this.querySelector('[data-map-error]');
      loading.hidden = false;
      error.hidden = true;
      const fail = () => { if (!this.isConnected) return; loading.hidden = true; error.hidden = false; };
      try {
        await this.loadMapLibrary();
        if (!this.isConnected) return;
        const map = new window.maplibregl.Map({
          container: this.querySelector('[data-map]'),
          style: JSON.parse(this.querySelector('[data-sande-map-style]').textContent),
          center: [145, -28], zoom: 3, minZoom: 1, maxZoom: 17,
          renderWorldCopies: false, attributionControl: true,
          cooperativeGestures: true, dragRotate: false, pitchWithRotate: false
        });
        this.mapInstance = map;
        this.mapResizeObserver?.disconnect();
        this.mapResizeObserver = new ResizeObserver(() => {
          if (!this.mapInstance) return;
          map.resize();
          if (this.mapReady) { map.stop(); this.fitMap(0); }
        });
        this.mapResizeObserver.observe(this.querySelector('[data-map]'));
        map.touchZoomRotate.disableRotation();
        map.addControl(new window.maplibregl.NavigationControl({showCompass:false}), 'top-right');
        this.mapTimer = setTimeout(fail, 18000);
        map.on('error', () => { if (!this.mapReady) fail(); });
        map.on('load', () => {
          clearTimeout(this.mapTimer);
          loading.hidden = true;
          error.hidden = true;
          const canvas = document.createElement('canvas');
          canvas.width = 56; canvas.height = 72;
          const ctx = canvas.getContext('2d');
          ctx.beginPath();ctx.moveTo(28,70);ctx.bezierCurveTo(22,58,4,38,4,26);ctx.arc(28,26,24,Math.PI,0);ctx.bezierCurveTo(52,38,34,58,28,70);ctx.closePath();ctx.fillStyle='#3d3d3d';ctx.fill();ctx.lineWidth=3;ctx.strokeStyle='#f6f5ed';ctx.stroke();ctx.beginPath();ctx.arc(28,25,7,0,Math.PI*2);ctx.fillStyle='#f6f5ed';ctx.fill();
          map.addImage('sande-pin',ctx.getImageData(0,0,56,72),{pixelRatio:2});
          map.addSource('sande-stores',{type:'geojson',data:{type:'FeatureCollection',features:[]},cluster:true,clusterRadius:16,clusterMaxZoom:8,clusterMinPoints:3});
          map.addLayer({id:'sande-clusters',type:'circle',source:'sande-stores',filter:['has','point_count'],paint:{'circle-color':'#3d3d3d','circle-stroke-color':'#f6f5ed','circle-stroke-width':1,'circle-radius':['step',['get','point_count'],14,10,17,30,21]}});
          map.addLayer({id:'sande-cluster-counts',type:'symbol',source:'sande-stores',filter:['has','point_count'],layout:{'text-field':['get','point_count_abbreviated'],'text-allow-overlap':true,'text-ignore-placement':true,'text-font':['Noto Sans Regular'],'text-size':12},paint:{'text-color':'#f6f5ed'}});
          map.addLayer({id:'sande-pins',type:'symbol',source:'sande-stores',filter:['!', ['has','point_count']],layout:{'icon-image':'sande-pin','icon-anchor':'bottom','icon-allow-overlap':true}});
          map.on('click','sande-clusters',async event => {
            const feature = event.features?.[0];
            if (!feature) return;
            try {
              const zoom = await map.getSource('sande-stores').getClusterExpansionZoom(feature.properties.cluster_id);
              map.easeTo({center:feature.geometry.coordinates,zoom,duration:this.motionDuration()});
            } catch (_) {}
          });
          map.on('click','sande-pins',event => {
            const feature = event.features?.[0];
            if (feature) this.openStore(this.rows[feature.properties.rowIndex],feature.geometry.coordinates);
          });
          for (const layer of ['sande-clusters','sande-pins']) {
            map.on('mouseenter',layer,()=>{map.getCanvas().style.cursor='pointer';});
            map.on('mouseleave',layer,()=>{map.getCanvas().style.cursor='';});
          }
          this.mapReady = true;
          this.syncMap();
          if (this.pendingRow) { const row=this.pendingRow;this.pendingRow=null;this.locate(row); }
        });
      } catch (_) { fail(); }
      finally { this.mapStarting = false; }
    }
    loadMapLibrary() {
      if (window.SandeStockistMapLoader) return window.SandeStockistMapLoader;
      const load = (type,url) => new Promise((resolve,reject) => {
        const element = document.createElement(type);
        if (type === 'link') {element.rel='stylesheet';element.href=url;}
        else {element.src=url;element.async=true;}
        const timer=setTimeout(()=>{element.remove();reject(new Error('Map dependency timed out'));},15000);
        element.onload=()=>{clearTimeout(timer);resolve();};
        element.onerror=()=>{clearTimeout(timer);element.remove();reject(new Error('Map dependency unavailable'));};
        document.head.appendChild(element);
      });
      window.SandeStockistMapLoader = Promise.all([
        load('link','https://unpkg.com/maplibre-gl@5.6.0/dist/maplibre-gl.css'),
        window.maplibregl ? Promise.resolve() : load('script','https://unpkg.com/maplibre-gl@5.6.0/dist/maplibre-gl.js')
      ]).catch(error=>{window.SandeStockistMapLoader=null;throw error;});
      return window.SandeStockistMapLoader;
    }
    motionDuration() { return matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 500; }
    features() {
      return (this.filteredRows || this.rows || []).flatMap(row => row.points.map(point => ({type:'Feature',geometry:{type:'Point',coordinates:point},properties:{rowIndex:row.index}})));
    }
    syncMap() {
      if (!this.mapReady) return;
      this.popup?.remove();
      this.mapInstance.getSource('sande-stores').setData({type:'FeatureCollection',features:this.features()});
      this.fitMap();
    }
    fitMap(duration = this.motionDuration()) {
      if (!this.mapReady) return;
      const points=this.features().map(feature=>feature.geometry.coordinates);
      if (!points.length) return;
      const bounds=new window.maplibregl.LngLatBounds();
      points.forEach(point=>bounds.extend(point));
      this.mapInstance.fitBounds(bounds,{padding:44,maxZoom:11,duration});
    }
    locate(row) {
      if (!row || !row.points.length) return;
      this.querySelector('.sande-stockists__map').scrollIntoView({behavior:'auto',block:'nearest'});
      if (!this.mapReady) {this.pendingRow=row;this.startMap();return;}
      if (row.points.length>1) {
        const bounds=new window.maplibregl.LngLatBounds();row.points.forEach(point=>bounds.extend(point));
        this.mapInstance.fitBounds(bounds,{padding:70,maxZoom:13,duration:this.motionDuration()});
      } else this.mapInstance.easeTo({center:row.points[0],zoom:14,duration:this.motionDuration()});
      this.openStore(row,row.points[0]);
    }
    openStore(row,point) {
      if (!row) return;
      this.popup?.remove();
      this.rows.forEach(item=>item.element.removeAttribute('data-selected'));
      row.element.dataset.selected='true';
      const box=document.createElement('div');box.className='sande-stockists__popup';
      const title=document.createElement('h4');title.textContent=row.element.querySelector('h4').textContent;box.appendChild(title);
      for (const selector of ['.sande-stockists__address','.sande-stockists__product-note']) {
        const original=row.element.querySelector(selector);
        if (original) {const p=document.createElement('p');p.textContent=original.innerText;box.appendChild(p);}
      }
      const link=row.element.querySelector('a');
      if (link) {const copy=link.cloneNode(true);box.appendChild(copy);}
      const show=document.createElement('button');show.type='button';show.textContent=this.dataset.showDirectory;show.addEventListener('click',()=>{
        row.element.closest('details').open=true;
        row.element.scrollIntoView({behavior:'auto',block:'center'});
        const target=row.element.querySelector('a,button');target?.focus({preventScroll:true});
      });box.appendChild(show);
      this.popup=new window.maplibregl.Popup({offset:28,maxWidth:'280px',focusAfterOpen:true}).setLngLat(point).setDOMContent(box).addTo(this.mapInstance);
    }

    normalize(value) {
      return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/&/g, ' and ').replace(/['’]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
    }
  }
  customElements.define('sande-stockist-locator', SandeStockists);
})();



  } catch(e) { console.error(e); }
})();
})();
